<template>
  <div class="page">
    <img src="@/assets/page/img1.jpg" class="top-img" />
    <div class="nav-img">
      <img src="@/assets/page/img2.png" class="top-img" @click="toUrl()" />
      <img src="@/assets/page/img3.png" class="top-img" />
    </div>
  </div>
</template>
<script>
export default {
    data(){
        return{

        }
    },
    methods:{
        toUrl(){
            location.href='https://ncymkj.doudou00.com/index.php?g=Wap&m=Index&a=lists&classid=19072&token=urbrto1489483674'
        }

    }
}
</script>
<style scoped>
.top-img {
  width: 100%;
}
.nav-img{
    width: 95%;
    margin: 10px auto;
}

</style>


// WEBPACK FOOTER //
// src/page/page.vue